module.exports = __webpack_public_path__ + "b952f7d3bebc61f1adc65afcd09fb9f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-img/blurred-img-3.jpg
// module id = 402
// module chunks = 0